import { TYPES } from "../../common/constants";

export const addFilterQuery = (payload) => ({
  type: TYPES.ADD_FILTER_QUERY,
  payload,
});
export const clearFilterRequestDone = () => ({
  type: TYPES.CLEAR_FILTER_REQUEST,
});
